/* eslint-disable @typescript-eslint/no-unused-vars */ // TODO: remove this when chart are either removed or implemented
import { lazy, Suspense } from 'react';
import ValidationsView from '@efex-components/newRegisterValidations/ValidationsView';
import NewAddFundsModal from '@efex-components/payables/addFundModal/NewAddFundsModal';
import { Actions, Can, Subjects, useRole } from '@efexteam/permission-manager';
import { Grid } from '@mui/material';
import LendingButton from '@pages/lending/components/Lending/LendingButton/LendingButton';
import { selectBusiness } from '@pages/profile/store/selectors';
import 'react-drop-zone/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { paymentIconBlue } from '../../assets';
import PaymentModal from '../../components/payables/PaymentModal';
import { PaymentFormProvider } from '../../components/payables/PaymentModal/context';
import OutletLayout from '../../layout/OutletLayout';
import WalletInitializer from '../../modules/wallets/WalletInitializer';
import ConvertButton from './components/ConvertButton/ConvertButton';
import PaymentLinkButton from './components/PaymentLinkButton/PaymentLinkButton';
import Wallets from './components/wallets';
import './dashboard.scss';
import useDashboard from './hooks/useDashboard';
import usePaymentModal from './hooks/usePaymentModal';

const ChinaPaymentsModal = lazy(() => import('../../components/chinaPayments'));

const dontShowConvertButton = false;

const Dashboard = () => {
  const { t } = useTranslation();
  const { isPaymentAnalyst, isOwner } = useRole();
  const { businessName } = useSelector(selectBusiness) || {
    businessName: 'EFEX',
  };
  const {
    openPaymentModal,
    selectedClientEmail,
    handleClosePreselectedClient,
  } = usePaymentModal();

  const {
    addFundsCurrency,
    addFundsWalletType,
    chartsData, // TODO: remove charts (?)
    chartsLoading, // TODO: remove charts (?)
    isAddFundsModalOpen,
    paymentOutModal,
    userProfile,
    handleAddFunds,
    handleClosePaymentModal,
    hideAddFundsModal,
    openPopupAddFunds,
    openPopupMakeNew,
  } = useDashboard({ setOpenPaymentModal: handleClosePreselectedClient });

  return (
    <OutletLayout title={isOwner ? 'Dashboard' : businessName}>
      <ValidationsView />
      <Grid container spacing={3}>
        {dontShowConvertButton ? <ConvertButton /> : null}
        <Grid item xs={12}>
          <WalletInitializer>
            <Wallets
              onDeposit={openPopupAddFunds}
              onPayment={openPopupMakeNew}
              onAddFundsCurrency={handleAddFunds}
            />
          </WalletInitializer>
        </Grid>
        <Can action={Actions.CREATE} subject={Subjects.PAYMENT_LINKS}>
          {userProfile?.company.isActivePaymentLink ? (
            <PaymentLinkButton />
          ) : (
            <LendingButton />
          )}
        </Can>
        <Can action={Actions.CREATE} subject={Subjects.PAYMENTS}>
          <Grid item xs={12} lg={6}>
            <button
              type="button"
              onClick={() => openPopupMakeNew()}
              disabled={!userProfile?.canUserWithdraw}
              className="box-rectangle border-[#006BF8] mb-3 box-rectangle-dash second-step bg-white disabled:opacity-50 disabled:border-gray-400 disabled:hover:bg-white h-full"
            >
              <div className="box-big_card">
                <div className="box-circle-img">
                  <img
                    className="dashboard__image_button"
                    src={paymentIconBlue}
                    alt="payment"
                  />
                </div>
                <span className="font-semibold">
                  {t(
                    isPaymentAnalyst ? 'configureNewPayment' : 'makeNewPayment'
                  )}
                </span>
              </div>
            </button>
          </Grid>
        </Can>
        {/*
        <PaymentsChart
          data={chartsData as IPaymentsBalance}
          loading={chartsLoading}
        /> */}
      </Grid>

      {(paymentOutModal || openPaymentModal) && (
        <PaymentFormProvider>
          <PaymentModal
            open={paymentOutModal || openPaymentModal}
            onClose={handleClosePaymentModal}
            selectedClientEmail={selectedClientEmail}
          />
        </PaymentFormProvider>
      )}

      {isAddFundsModalOpen ? (
        <NewAddFundsModal
          open={isAddFundsModalOpen}
          initCurrency={addFundsCurrency.current}
          initWalletType={addFundsWalletType.current}
          onClose={hideAddFundsModal}
        />
      ) : null}
      <Suspense fallback={<>...</>}>
        <ChinaPaymentsModal sendPayment={openPopupMakeNew} />
      </Suspense>
    </OutletLayout>
  );
};

export default Dashboard;
